import { render, staticRenderFns } from "./ParamsDialog.vue?vue&type=template&id=47e12612&"
import script from "./ParamsDialog.vue?vue&type=script&lang=js&"
export * from "./ParamsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports